export const stripTime = (date: unknown): string =>
  typeof date === 'string' ? date.split('T')[0] : '';
